module.exports = __webpack_public_path__ + "img/logo.1f1dbf76.png";